import React, { useState } from "react";

import { Form, Input, Select, Button, Col, Row } from "antd";
import { v4 as uuidv4 } from "uuid";

function CreditCard({ creditCards, setCreditCards }) {
  const addCreditCards = () => {
    const newCreditCards = {
      id: uuidv4(),
      issuer: "",
      balance: "",
    };
    setCreditCards([...creditCards, newCreditCards]);
  };

  const removeCreditCards = (id) => {
    const updatedCreditCards = creditCards.filter((item) => item.id !== id);
    setCreditCards(updatedCreditCards);
  };

  const handleChange = (value, name, id) => {
    const updatedCreditCards = creditCards.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setCreditCards(updatedCreditCards);
  };

  return (
    <ul>
      {creditCards.map((item, index) => (
        <li key={item.id}>
          <Form.Item label="">
            <Row>
              <Col span={18}>
                <Form.Item
                  label=" "
                  name={`creditCardIssuer${index}`}
                  rules={[
                    {
                      required: true,
                      message: "Please enter Credit Card Issuer!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Issuer"
                    onChange={(e) =>
                      handleChange(e.target.value, "issuer", item.id)
                    }
                  />
                </Form.Item>
              </Col>

              <Col span={5}>
                <Form.Item label=" ">
                  <Input
                    placeholder="Balance"
                    prefix="$"
                    onChange={(e) =>
                      handleChange(e.target.value, "balance", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={1}>
                {creditCards.length > 1 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removeCreditCards(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Form.Item>
        </li>
      ))}

      <Form.Item label="">
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={addCreditCards}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          Add Another Credit Card
        </Button>
      </Form.Item>
    </ul>
  );
}

export default CreditCard;
